import { LogHelper } from "@/common/LogHelper";

const one = require("@/assets/man1.wav");
const two = require("@/assets/man2.wav");
const three = require("@/assets/man3.wav");
const four = require("@/assets/man4.wav");
const five = require("@/assets/man5.wav");
const six = require("@/assets/man6.wav");
const seven = require("@/assets/man7.wav");
const eight = require("@/assets/man8.wav");
const nine = require("@/assets/man9.wav");
// const ten = require("@/assets/ten.wav");

const soundList = [];
const audio1 = new Audio();
audio1.src = one;
soundList["1"] = audio1;
const audio2 = new Audio();
audio2.src = two;
soundList["2"] = audio2;
const audio3 = new Audio();
audio3.src = three;
soundList["3"] = audio3;
const audio4 = new Audio();
audio4.src = four;
soundList["4"] = audio4;
const audio5 = new Audio();
audio5.src = five;
soundList["5"] = audio5;
const audio6 = new Audio();
audio6.src = six;
soundList["6"] = audio6;
const audio7 = new Audio();
audio7.src = seven;
soundList["7"] = audio7;
const audio8 = new Audio();
audio8.src = eight;
soundList["8"] = audio8;
const audio9 = new Audio();
audio9.src = nine;
soundList["9"] = audio9;
// const audio10 = new Audio();
// audio10.src = ten;
// soundList["10"] = audio10;

export { soundList };

const voices = [];


export function playLayerVioce(layerNum) {
  try {
    play(layerNum)
    LogHelper.VoiceLog("播放声音分层:" + layerNum.toString());
  } catch (error) {
    LogHelper.Error("声音分层出现错误:" + error);
  };
}


export function FloorVoiceInit() {
  if (voices.length == 0) {
    getVoicePath();
  }
}

function getFilePath(path: string) {
  if (path.indexOf("\\") == -1) {
    return path;
  } else {
    let pathArr = path.split("\\");
    return pathArr[pathArr.length - 1];
  }
}

function getVoicePath() {
  try {
    //加载前7层的声音文件
    let systemConfig = JSON.parse(obj_GlobalData_Core.getSystemConfig());
    let voiceConfig = systemConfig?.TipVoiceLayerConfig.TipVoiceLayers;
    //加载8/9/10层的声音文件
    let ytoCommonConfig = JSON.parse(obj_GlobalData_Core.getYtoCommonConfig());
    voiceConfig.push({
      TipVoiceLayerName: "TipVoiceLayer8",
      TipVoiceLayerPath: ytoCommonConfig.TipVoiceLayer8,
      TipVoiceLayer_Type: 8
    });
    voiceConfig.push({
      TipVoiceLayerName: "TipVoiceLayer9",
      TipVoiceLayerPath: ytoCommonConfig.TipVoiceLayer9,
      TipVoiceLayer_Type: 9
    });
    voiceConfig.push({
      TipVoiceLayerName: "TipVoiceLayer10",
      TipVoiceLayerPath: ytoCommonConfig.TipVoiceLayer10,
      TipVoiceLayer_Type: 10
    });

    LogHelper.VoiceLog(JSON.stringify(voiceConfig));
    voiceConfig.forEach(element => {
      let strPath = "";
      if (element.TipVoiceLayerPath.indexOf(":") == -1) {
        strPath = "\\Sound\\" + element.TipVoiceLayerPath;
      } else {
        strPath = element.TipVoiceLayerPath;
      }
      let base64 = obj_File_Core.getFile(strPath);
      if (base64 != "") {
        let byteArr = dataURLtoFile(base64);

        let voiceUrl = window.URL.createObjectURL(byteArr);
        // voices.push({NoticeVoiceType: element.TipVoiceLayerName, path: voiceUrl});
        const player = new Audio();
        player.src = voiceUrl;
        voices[element.TipVoiceLayerName.replace("TipVoiceLayer", "")] = player;
      }else{
        LogHelper.VoiceLog("声音分层:"+element.TipVoiceLayerName+"未加载");
      }
    });


  } catch (error) {
    LogHelper.Error("声音加载错误");
    LogHelper.Error(error);
  }
}

const player = new Audio();

function play(layer) {
  try {
    debugger;
    if (voices.length == 0) {
      getVoicePath();
    }
    if (voices.length == 0) {
      LogHelper.VoiceLog("声音路径加载不成功:请检查客户端路径配置或者检查网页资源中声音文件是否存在");
      return;
    }
    // let voicePath = voices.filter(element => element.NoticeVoiceType === "TipVoiceLayer" + layer);
    // var voiceAsset: string = voicePath[0].path;

    // player.src = voiceAsset;
    // player.play();

    let _layer = Number.parseInt(layer);
    voices[_layer].play();
    LogHelper.VoiceLog("play(layer):" + layer.toString());
  } catch (error) {
    LogHelper.Error("声音提示错误:" + error);
  }

}

// 生成Blob 网址
function dataURLtoFile(dataurl) {
  var bstr = atob(dataurl);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: "audio/x-wav" });
}
